import { gql } from 'glimmer-apollo';
import { GAME_ARTICLE_FRAGMENT, ESPORTS_ARTICLE_FRAGMENT } from '../fragments/common';

export const NEWS_POST_QUERY = gql`
  ${GAME_ARTICLE_FRAGMENT}
  ${ESPORTS_ARTICLE_FRAGMENT}
  
  query ($slug: String) {
    article: gameArticle(slug: $slug) {
      title
      slug
      shortDescription
      publishedDate
      body
      coverImage {
        url
      }
      author {
        name
        bio
        socialLinks {
          url
          platform
          accessibilityDescription
        }
        avatar {
          url
        }
      }
      relatedArticles {
        __typename
        title
        shortDescription
        slug
        publishedDate
        coverImage {
          url
        }
        author {
          name
          avatar {
            url
          }
        }
      }
    }
    popularGameArticles: gameArticles(limit: 2) {
      ...GameArticleInfo
    }
    popularEsportsArticles: eSportsArticles(limit: 2) {
      ...ESportsArticleInfo
    }
  }
`;
